import { render } from "./copytext.vue?vue&type=template&id=f63469e0&scoped=true"
import script from "./copytext.vue?vue&type=script&lang=js"
export * from "./copytext.vue?vue&type=script&lang=js"

import "./copytext.vue?vue&type=style&index=0&id=f63469e0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63469e0"]])

export default __exports__